export default "__VITE_ASSET__82ac53f6__"